import './App.css';

function App() {
  return (
    <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif", padding: "50px" }}>
      <h1>Learn English with Allie</h1>
      <p>Private ESL tutoring with Ivy League graduate and native English Speaker</p>
    </div>
  );
}

export default App;
